import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson18: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-start p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson17"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">How To Trade</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson19"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[8rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>{`Refer to our `}</span>
            <a
              className="text-[inherit]"
              href="/61d57a6dbd9f46f18af44fc80542698f"
              target="_blank"
            >
              <span>
                <span className="[text-decoration:underline]">{`Exchanges Guide `}</span>
              </span>
            </a>
            <span>
              for more information on what exchange works best for your regional
              and experience level circumstances!
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>What Is Trading?</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Trading is a fundamental economic concept that involves buying and
            selling assets. These can be goods and services, where the buyer
            pays the compensation to the seller. In other cases, the transaction
            can involve the exchange of goods and services between the trading
            parties.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In the context of the financial markets, the assets being traded are
            called financial instruments. These can be stocks, bonds, currency
            pairs on the Forex market, options, futures, margin products,
            cryptocurrency, and many others. If these terms are new to you,
            don’t worry – we’ll explain them all later in this article.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The term trading is commonly used to refer to short-term trading,
            where traders actively enter and exit positions over relatively
            short time frames. However, this is a slightly misleading
            assumption. In fact, trading may refer to a wide range of different
            strategies, such as day trading, swing trading, trend trading, and
            many others. But don’t worry. We’ll go through each of them in more
            detail later.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>How To Place A Trade</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              To place a market order, simply press “market” or “limit”, enter
              the preferred leverage and the quantity (Qty) in USD value and
              you’re ready to go. If you look at your Order Value, this number
              will represent the value of your initial margin plus the leverage
              you use to open the position.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              The actual cost to open the position is visible further down in
              the image below the “Long” and “Short” buttons. The cost in this
              example is 1/10 of the Order Value, because we are using 10x
              leverage in this example. “Available Margin” simply shows you what
              you currently have in your account to trade with.
            </p>
          </div>
          <img
            className="relative w-[29.69rem] h-[42rem] object-cover"
            alt=""
            src="/i72@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>{`Stop Loss & Take Profit`}</b>
            </p>
            <p className="m-0 text-[1.56rem] text-gainsboro-100">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>{`Remember that one very important thing in trading is a stop-loss. Now, if you click “Long” or “Short”, you will see a pop-up screen, as per the image below. Here, you can enter a take profit and a stop loss level, and when you press “Confirm” in the bottom right corner, your market order will be executed and `}</span>
                <b>
                  your take profit and stop loss levels will enter the order
                  book as conditional orders that will trigger automatically if
                  price meets that level.
                </b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span className="font-dm-sans">
                  Before you press “Confirm”, review the order. Make sure that
                </span>
                <b className="font-dm-sans">
                  {" "}
                  the leverage is correct and that the liquidation price is a
                  level
                </b>
                <span>
                  {" "}
                  that you are comfortable with. Also, very important is to make
                  sure that your stop loss will be hit before your liquidation
                  price. If you agree to all the terms, press “Confirm”.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[29.69rem] h-[42rem] object-cover"
            alt=""
            src="/i73@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>The Main Types of Crypto Trading</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In the crypto trading world, there are two main forms of
                  trading support by global exchanges.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Spot Trading</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Crypto Derivatives (Focus on Futures Trading)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Spot trading `}</b>
                <span>
                  is the process of buying and selling tokens and coins at a
                  spot price for immediate settlement. You own the underlying
                  cryptocurrency.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Crypto Derivatives</b>
                <span>
                  {" "}
                  are secondary contracts or financial trading tools that derive
                  their value from a primary underlying asset like Bitcoin.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Futures trading</b>
                <span>
                  {" "}
                  is the process of purchasing a contract with an agreement to
                  buy or sell a specific cryptocurrency at a future date. You do
                  not own the underlying cryptocurrency.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>
                  <span>Introduction To Crypto Spot Trading</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <b>Cryptocurrency spot trading</b>
                  <span>
                    {" "}
                    is the process of buying and selling digital assets such as
                    Bitcoin or Ethereum for immediate delivery. They are
                    directly transferred between the market participants (buyers
                    and sellers). In a spot market, you have direct ownership of
                    the cryptocurrency and are entitled to economic benefits
                    such as staking participation, voting rights, etc.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Popular crypto exchanges like Binance, Coinbase Pro, etc.
                    all support spot trading.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[23.63rem] object-cover"
            alt=""
            src="/i74@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          This allows users to conduct fiat-to-crypto or crypto-to-crypto
          transactions. Think of spot trading as the intermediary between buyers
          and sellers to place bids and asks for a specific crypto asset. When
          either is matched, the exchange will execute the trade. Spot trading
          operates 24 hours a day / 7 days a week, which means you can buy and
          sell crypto any time and any day.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Spot Trading Example (Buying Bitcoin)</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Jacob wants to buy BTC with Fiat currency (USD) in the spot
                market. How would he do so?
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  He would go to an exchange that supports spot trading within
                  his respective region/country
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Jacob will then look and identify a trading pair of BTC/USD
                  within the trading section of his exchange.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`He will then place a buy order at his desired price & quantity for his trade to execute at`}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Upon immediate trade execution he will have his BTC stored in
                  his spot wallet
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  He is free to choose to hold until value increases and then
                  sell or hold indefinitely
                </span>
              </span>
            </li>
          </ul>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Jacob is smart because he knows holding his cryptocurrency in
                  the spot market can potentially lead to capital appreciation
                  since the value of his crypto can increase over time.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[8rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] inline-block h-[24.13rem]">
            <p className="m-0">
              <b>
                <span>Introduction To Crypto Derivatives</span>
              </b>
            </p>
            <p className="m-0">
              <b>
                <span>(Futures Trading)</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span className="font-dm-sans">{`A `}</span>
                  <b className="font-dm-sans">derivative</b>
                  <span>
                    {" "}
                    is a contract or product whose value is determined by an
                    underlying asset. Some examples of derivative assets can be
                    wrapped tokens (WETH, rather than ETH), stocks, rate of
                    interests, currencies, exchanges rates, etc.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    The buyer and seller of these contracts have directly
                    opposed predictions for the future trading price of that
                    asset. Both of these opposing sides "bet" on the underlying
                    assets' future value in order to earn a profit.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[26.75rem] object-cover"
            alt=""
            src="/i75@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Introduction To Crypto Derivatives</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Let's take a look at this crypto derivative trading breakdown
                  below to better understand.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Crypto Derivative Trading Facts:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    The underlying asset in crypto derivatives can be any
                    cryptocurrency token.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Both parties that enter into this financial contract bet on
                    the cryptocurrency's price at a future date.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Within this contract, both sides agree on a buying/selling
                    price for that cryptocurrency on a specified day. (Despite
                    whatever market price is)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Investors/traders can then profit from changes in the
                    underlying asset’s price by purchasing the currency at a
                    cheaper price and selling it at a higher price.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    This difference in price is what the other party will have
                    to pay should they speculate wrong.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  We will explain this further, showcasing Futures below.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[8rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Crypto Futures Trading</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span className="font-dm-sans">{`A `}</span>
                  <b className="font-dm-sans">futures contract</b>
                  <span>
                    {" "}
                    is basically a contract or an agreement between two opposing
                    parties to purchase and sell a specific cryptocurrency at a
                    given price at a specific future date. The contract is
                    directly executed on a regulated cryptocurrency exchange.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    In futures trading, you are buying or selling contracts that
                    represent the value of a specific cryptocurrency. In the
                    futures crypto market, you don't own the underlying
                    cryptocurrency like in spot trading. But rather, you own a
                    contract with an agreement to buy or sell that specific
                    cryptocurrency at a future date.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[24rem] object-cover"
            alt=""
            src="/i76@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          Ownership of a futures contract does not give you any benefits like
          voting and staking.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Pros of Futures Trading:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Protection against volatility and adverse price movements on
                  underlying asset
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Proxy tool for traders to speculate future prices</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Removes the cost and hassle of storing cryptocurrencies
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Higher Potential Profits</span>
              </span>
            </li>
            <li>
              <span>
                <span>Flexible Trading Strategies</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Cons of Futures Trading:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Premature (Some experts believe the underlying crypto market
                  isn't mature enough for futures to exist
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Leverage Misuse</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Higher than recommended leverage might seem enticing to
                  beginners causing them to be at very high risks.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Along with increased potential returns comes increased
                  potential losses
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>High Risk</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  With the crypto market already being extremely volatile,
                  derivative contracts like futures are even more volatile due
                  to fluctuations in the value of the underlying cryptocurrency.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Speculative - Unpredictability can lead to large losses
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Please make sure you take a look at our Further Resources at
                  the bottom of this guide for more information regarding
                  futures trading. It's important you are able to comprehend the
                  basics of what it is before engaging in any type of future
                  trades.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[8rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>
                  <span>Leveraging</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <b>Leverage</b>
                  <span>
                    {" "}
                    is the use of debt (borrowed capital) for your own personal
                    trades.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Usually classified as a type of margin trading which is
                    trading with borrowed funds.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    An investor with insufficient capital may choose to use
                    borrowed capital for a certain trade they might be extremely
                    confident in. Leverage will allow for them to increase their
                    potential returns. However, with this borrowed leverage
                    comes the same amount of increased risk. If the trade
                    doesn't go as planned the investor will end up having more
                    debt than returns/assets.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[27.31rem] object-cover"
            alt=""
            src="/i77@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">Let's look at an example of how leverage works:</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            {`Timmy wants to buy Crypto A with a minimum of $1,000 `}
            <a
              className="text-[inherit]"
              href="https://www.notion.so/f153d5f3ecab4ef2b400145490f3fc2e?pvs=21"
              target="_blank"
            >
              <span className="[text-decoration:underline]">
                standard lot size
              </span>
            </a>{" "}
            but he only has $100. He decides to use leverage.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">Here are the scenarios that he can use:</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            10X Leverage: $100 (base investment) x 10X (leverage) = $1,000
          </p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              Timmy will be able to buy $1,000 worth of Crypto A with only $100
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            20X Leverage: $100 (base investment) x 20X (leverage) = $2,000
          </p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              Timmy will be able to buy $2,000 worth of Crypto A with only $100
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">So what happens now?</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If the price of Crypto A goes up as he expected, he will be making
            some very nice returns! However, if the price goes down, his high
            leverage usage comes with accelerated liquidation (selling off of
            assets). Liquidation means all money in his account will be lost.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Beginners should avoid using too high of leverage levels on their
            plays. Minimal leverage levels will do just fine. Your selected
            leverage decides the margin required for the trade. For example, if
            Timmy decides to use 10X leverage, his position will have 10% of his
            funds while the rest will be borrowed.
          </p>
        </div>
        <b className="self-stretch relative text-[2.81rem] font-nunito text-center">
          Key Differences
        </b>
        <b className="self-stretch relative text-[1.88rem] tracking-[0.02em] leading-[2rem]">
          Crypto Spot Trading vs Crypto Futures Trading
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Leverage</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Futures trading attracts traders that prefer leverage due to
                  it's capital efficiency.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Purchasing 1 BTC in spot market requires ~50K USD</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  You can open a BTC futures position for a fraction of that
                  cost.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Higher leverage = the less you spend on a position</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Spot trading does not offer leverage.</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Only having 10,000 USDT you can only purchase $10K worth of
                  bitcoin.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Long or Short Flexibility</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Purchasing BTC in spot market</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Only make profits if price goes up</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Cannot make money in a bear market</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Purchasing BTC in futures market</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Potential to profit regardless of the direction of short term
                  price movement
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Allows for traders to develop strategies like short-selling,
                  pairs trading, arbitrage, etc.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Acts as a hedge against downside risk and protect your
                  portfolio from volatility
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Liquidity</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Futures Market</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  BTC futures market has an average monthly volume of $2
                  Trillion
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Higher liquidity leads to less risk (more willingness for both
                  parties)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Spot Market</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  BTC spot market has far less average monthly volumes
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Lower liquidity</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Spot trading is intuitive and easiest to understand for
                beginners to crypto trading. However, futures trading is more
                complex but offers more opportunities for higher profit along
                with strategic advantages.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It would be wise to first learn about spot trading and develop
                your knowledge and risk management skills before diving into
                futures trading. This will help you minimize any potential
                losses. Do your due diligence and research before trading
                futures.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Take a look at our Further Resources section at the bottom of
                this guide for some great basis informational videos you can
                look at to understand better.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Scalp vs Swing Trading</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A common method for distinguishing one type of trader from
                another is the time period in which they hold a cryptocurrency.
                That time period can from a few seconds (scalpers) to days (day
                trader) to months/years (swing traders).
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Scalp Trading</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  This type of trading targets small changes in daily stock
                  price movement.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Frequently entering and exiting plays to build profits.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Thus this results in smaller, quicker gains/losses</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Higher stress</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Higher commissions (cost of trading)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Often classified as day trading since both include trading
                  within the same day
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Average scalp trader carries out multiple trades in a day
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Limited time of market exposure lowers trading risk</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Focuses on short periods on trading charts</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>1/3/5 Minute Interval</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Best suited for those that have time on their hands to devote to
                watching the markets. They must be able to stay focused and
                execute trades quickly. It is for those who can handle stress,
                make quick decisions, and act accordingly.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Swing Trading</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  These traders use technical analysis and charts that display
                  price actions.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Allows for locating best entry/exit points profitable trades.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>This type of trading targets trends in the market</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Identifies trending cryptocurrencies and plays the trend
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Usually after a correction/consolidation</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Uptrend = long , downtrend = short</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Swing trades or positions are opened for more than a day
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Typically last a few days to weeks</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Few trades per trading session</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Lower trading fees (broker fees)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Identifies resistance and support patterns on charts
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Technical Indicators to assist with entry/exit decisions
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Full exposure to market risk</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>High Risk</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>News, and overnight events can effect markets</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Best suited for those that are able to reasonably monitor the
                markets. Part-time traders flock here because of the limited
                attention needed as opposed to minute-by-minute monitoring with
                scalp trading. However, they still must be updated on crypto
                news and headlines and be able to handle sudden levels of
                volatility.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Both trading categorizations come with their own set of risks
                and rewards. There is no single 'perfect strategy' that suits
                all traders. Identify your skill level, risk appetite, time able
                to be devoted, account size, and trading knowledge so you can
                decide what trading strategy works better for you at any given
                time.
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson19">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson18;
